import * as React from "react";
import {Link} from "react-router-dom";
import {getBrandFromPolicyNumber, WarningBanner, resourcesHelper} from "@ferry/portal-core";

interface IProps {
    smallScreenMarginRequired?: boolean,
    policyNumber: string,
}

export class InactiveDirectDebitBanner extends React.Component<IProps> {

    public render(): React.ReactNode {

        const pathName = `/dashboard/${this.props.policyNumber}/paymentDetails/editDirectDebit/`;
        const brandName: string = this.props.policyNumber ?
            getBrandFromPolicyNumber(this.props.policyNumber)! :
            resourcesHelper.THEME_NAME;

        return (
            <WarningBanner wording={
                <>
                    You no longer have an active Direct Debit with {brandName}.
                    <div>
                        <Link id="payNow"
                            className="btn btn-white-dashboard"
                            aria-label={"Pay Now"}
                            to={{pathname: pathName}}
                            state={{policyNumber: this.props.policyNumber}}
                        >
                        Set-up your Direct Debit</Link>
                    </div>
                </>
            }/>
        )}
}
